const PaginationDummy = () => {
  return (
    <div className="boxed-content">
      <div className="pagination">{/** dummy pagination for consistent padding */}</div>
    </div>
  );
};

export default PaginationDummy;
